<div class="blank-layout-container justify-content-center">
  <div class="row">
    <div class="col-12 text-center">
      <mat-icon class="icon-403" style="font-size: 200px; width: 200px; height: 200px; color: #f44336;">vpn_lock</mat-icon>
      <h2 class="auth-title f-w-600">Access Forbidden</h2>
      <h6 class="f-s-20 f-w-600 m-y-30">You must activate your VPN to access ArturPro.</h6>
      <p class="f-s-16 m-y-20">Please enable your VPN connection and try again.</p>
      <a mat-flat-button color="primary" [routerLink]="['/']">Go back to Home</a>
    </div>
  </div>
</div>

